export class AuthenticationRequiredError extends Error {
  readonly status = 401

  constructor(message = 'Authentication is required') {
    super(message)
    this.name = 'AuthenticationRequiredError'
  }
}

export const isAuthenticationRequiredError = (error: unknown): boolean => {
  if (error instanceof AuthenticationRequiredError) {
    return true
  }

  return typeof error === 'object' && error !== null && 'status' in error && error.status === 401
}
